import React, { useState, useRef, useEffect } from 'react';
import { Icon } from 'semantic-ui-react';

const CustomDropdown = ({ 
  placeholder = 'Select', 
  options = [], 
  value, 
  onChange, 
  icon,
  style = {},
  dropup = false,
  searchable = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isOpen && searchable && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isOpen, searchable]);

  const selectedOption = options.find(o => o.value == value);

  const filteredOptions = searchable 
    ? options.filter(o => o.text.toLowerCase().includes(searchTerm.toLowerCase()))
    : options;

  return (
    <div 
      ref={dropdownRef}
      style={{ 
        flex: '0 1 auto', 
        minWidth: '150px', 
        display: 'flex', 
        alignItems: 'center', 
        backgroundColor: '#F5F5F7', 
        borderRadius: '12px', 
        padding: '0 16px',
        height: '48px',
        gap: '12px',
        position: 'relative',
        cursor: 'pointer',
        userSelect: 'none',
        ...style
      }}
      onClick={() => setIsOpen(!isOpen)}
    >
        {icon && <Icon name={icon} style={{ color: '#86868b', margin: 0, fontSize: '16px' }} />}
        
        <div style={{ flex: 1, fontSize: '14px', fontFamily: 'inherit', color: value ? '#1d1d1f' : '#888', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {selectedOption ? selectedOption.text : placeholder}
        </div>
        
        <Icon name='angle down' style={{ color: '#86868b', margin: 0, fontSize: '12px', transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }} />

        {isOpen && (
          <div style={{
            position: 'absolute',
            top: dropup ? 'auto' : 'calc(100% + 8px)',
            bottom: dropup ? 'calc(100% + 8px)' : 'auto',
            left: 0,
            right: 0,
            backgroundColor: 'white',
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            border: '1px solid rgba(0,0,0,0.05)',
            zIndex: 1000,
            maxHeight: '300px',
            overflowY: 'auto',
            padding: '6px',
            display: 'flex',
            flexDirection: 'column'
          }}
          onClick={(e) => e.stopPropagation()} 
          >
            {searchable && (
                <div style={{ padding: '8px', borderBottom: '1px solid #f0f0f0', marginBottom: '4px' }}>
                    <input
                        ref={searchInputRef}
                        type="text"
                        placeholder="검색..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                            width: '100%',
                            border: 'none',
                            outline: 'none',
                            fontSize: '14px',
                            color: '#1d1d1f',
                            backgroundColor: 'transparent'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
            )}

            <div style={{ overflowY: 'auto', flex: 1 }}>
                <div 
                onClick={() => {
                    onChange(null);
                    setIsOpen(false);
                    setSearchTerm('');
                }}
                className="custom-dropdown-item"
                style={{
                    padding: '10px 12px',
                    fontSize: '14px',
                    color: '#666',
                    cursor: 'pointer',
                    borderRadius: '8px',
                    marginBottom: '2px'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#F5F5F7'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                전체 보기
                </div>
                {filteredOptions.length > 0 ? filteredOptions.map(option => (
                <div 
                    key={option.key || option.value} 
                    onClick={() => {
                        onChange(option.value);
                        setIsOpen(false);
                        setSearchTerm('');
                    }}
                    className="custom-dropdown-item"
                    style={{
                    padding: '10px 12px',
                    fontSize: '14px',
                    color: '#1d1d1f',
                    cursor: 'pointer',
                    borderRadius: '8px',
                    backgroundColor: value == option.value ? '#F5F5F7' : 'transparent',
                    fontWeight: value == option.value ? '600' : 'normal',
                    marginBottom: '2px'
                    }}
                    onMouseEnter={(e) => { 
                        if (value != option.value) e.target.style.backgroundColor = '#F5F5F7'; 
                    }}
                    onMouseLeave={(e) => { 
                        if (value != option.value) e.target.style.backgroundColor = 'transparent'; 
                    }}
                >
                    {option.text}
                </div>
                )) : (
                    <div style={{ padding: '12px', fontSize: '13px', color: '#999', textAlign: 'center' }}>
                        결과 없음
                    </div>
                )}
            </div>
          </div>
        )}
    </div>
  );
};

export default CustomDropdown;